const debug = (...msg) => {
  console.log("[DEBUG]", ...msg);
};

export default debug;
